<template>
  <div>
    <v-btn class="btnDetails" icon x-large dark text style="margin-left:1vh;" @click="openDialog">
      <v-icon color="primary">mdi-currency-usd</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
      <template>
        <v-card class="container justify-content-between align-items-center">
          <button class="close-button" @click="closeDialog()">
            <span class="small-x">X</span>
          </button>
          <v-col cols="12" md="12" sm="6">
            <img alt="logoIbliss"
              src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
              class="custom-img" />
          </v-col>
          <h2 class="custom-title">{{ $t('usersAdmin.label.changeStateStar.title') }}</h2>

          <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
              indeterminate></v-progress-circular>
          </div>
          <div v-else>
            <div>
              <v-row dense class="mx-8 mt-5 mb-5 justify-center">
                <v-col cols="12" md="12" sm="12">
                  <p class="text-center">{{ $t('usersAdmin.label.changeStateStar.text') }}</p>
                  <p class="text-center font-weight-bold">{{ this.dataStar.firstName }} {{ this.dataStar.lastName }}</p>
                </v-col>

                <v-btn color="primary" @click="submitForm()" large rounded>
                  {{ $t('button.accept') }}
                </v-btn>
                <v-btn text @click="closeDialog()" large rounded class="ml-2">
                  {{ $t('button.cancel') }}
                </v-btn>
              </v-row>
            </div>
          </div>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  STARASSIGNMENT_M,
  GET_STATE_LOADING_STARASSIGNMENT
} from "@/views/star_assignment/store/types/types.js";

import {
  RECOGNITION_BUYING_M,
  ACTION_POST_CHANGE_STATE_START
} from "@/views/recognition/store/types/types.js";

export default {
  name: "ChangeStar",
  props: {
    dataStar: {
      required: false,
      default: null,
    },

  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      window.location.reload();
    },
    async submitForm() {
      try {
        const data = {
          userId: this.dataStar.userId,
          date: new Date().toISOString(),
        };
        const result = await this.postChangeStateStart(data);
        
        if (result) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: i18n.t('usersAdmin.actionPutUpdateUserAdmin.success'),
            showConfirmButton: false,
            timer: 2500
          });
          this.closeDialog();
        } 
      } catch (error) {
        console.error("Error en submitForm:", error);
        Swal.fire({
          icon: "error",
          text: error.data.payload.message,
          showConfirmButton: true,
        }).then(res =>{
          if (res.isConfirmed) {
            this.closeDialog();
          }
        });
      }
    },

    ...mapActions({
      postChangeStateStart: `${RECOGNITION_BUYING_M}${ACTION_POST_CHANGE_STATE_START}`,
    }),
  },

  computed: {
    ...mapGetters({
      loading: `${STARASSIGNMENT_M}${GET_STATE_LOADING_STARASSIGNMENT}`,
    }),
  },

};
</script>

<style lang="css" scoped>
body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
}

.small-x {
  font-size: smaller;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.custom-title {
  color: #6e17a5;
  justify-items: center;
}

.custom-text {
  font-size: 16px;
  color: #000000;
  text-align: center;
  margin: 5px;
}

.nombre {
  font-size: 14px;
  color: #414141;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6e17a5;
}

.v-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 900px) {
  .row {
    padding-top: 0vh;
  }

  .custom-img {
    width: 100px;
  }

  .custom-title {
    color: #6e17a5;
    justify-items: center;
    font-size: 28px;
  }
}
</style>
